/* eslint-disable prettier/prettier */
import { useState } from 'react';
import { assessmentSubmissionService } from '../services/assessmentSubmission.service';

export function useSubmitAssessment() {
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);
	const [progress, setProgress] = useState<number>(0);

	const submit = async (
		assessmentId: string,
		payload: {
			files: File[];
			answers?: Record<string, any>;
		},
		p0?: (percent: any) => void
	) => {
		setSubmitting(true);
		setProgress(0);
		setError(null);
		setSuccess(false);

		try {
			console.log('isnide assessment submission hook');
			const response = await assessmentSubmissionService.submitAssessment(
				assessmentId,
				payload,
				(percent: number) => {
					setProgress(percent);
					p0?.(percent); // keep callback working
				}
			);

			console.log('exiting assessment submission hook');
			setSuccess(true);
			return response; // ✅ ADD THIS
		} catch (err: any) {
			setError(err.message || 'Submission failed');
			throw err; // ✅ ADD THIS (CRITICAL)
		} finally {
			setSubmitting(false);
		}
	};

	return {
		submit,
		submitting,
		error,
		progress,
		success,
	};
}
